import React from "react"

import reducePlasticImage from "../images/reduce-plastic.jpg"
import container1Image from "../images/container-1.jpg"
import container2Image from "../images/container-2.jpg"
import containerWideImage from "../images/container-wide.jpg"

const Features = () => (
  <>
    <div className="o-grid__item--full o-grid-2">
      <img className="c-image" src={reducePlasticImage} alt="Reduce Plastic" />
      <div>
        <p className="c-body-text u-pad-right">
          When you are looking for economical alternatives for food packaging, turn to Yangrui’s brand-new hinged container product line. Yangrui’s hinged lid containers offer an enhanced environmental solution for your food packaging needs.
        </p>
        <div className="c-line c-line--horizontal"></div>
      </div>
    </div>

    <div className="o-grid__item--wide c-feature__grid">
      <div className="c-feature__column">
        <img className="c-image" src={container1Image} alt="Container 1" />
        <h3 className="c-heading c-feature__heading">Buckel and Embossed Design</h3>
        <p className="c-body-text">
          Adopt buckle design, better sealing, prevent food overflow. Surface embossed design, good texture, easy to remove, convenient and more elegant.
        </p>
        <div className="c-line c-line--horizontal" />
      </div>

      <div className="c-feature__column">
        <img className="c-image" src={container2Image} alt="Container 2" />
        <h3 className="c-heading c-feature__heading">Water and Oil Proofing</h3>
        <p className="c-body-text">
          Prevent oil and water leakage, health and environmental protection, lends itself perfectly to take-out and delivery applications as well as for food packaging.
        </p>
        <div className="c-line c-line--horizontal" />
      </div>

      <div className="c-feature__column c-feature__column--wide">
        <img className="c-image" src={containerWideImage} alt="Wide Container" />
        <div className="c-feature__image-text">
          <h3 className="c-heading c-feature__heading">Biodegradable</h3>
          <p className="c-body-text">
            Produced with 40% natural minerals, which reduce the amount of polypropylene material required — this results in a much lighter carbon footprint and greater price stability
          </p>
          <div className="c-line c-line--horizontal c-feature__line" />
        </div>
      </div>
    </div>
  </>
)

export default Features